module.exports = __webpack_public_path__ + "img/pitched-roof.07b4bcc3.png";